<template>
  <div>
    <van-nav-bar :left-text="$t('button.return')" :right-text="username" left-arrow title="出库复核" @click-left="onClickLeft" @click-right="goIndex()"/>
    <van-cell-group>
      <van-field ref="barcode" :label="$t('business.label.barcode')" autofocus clearable left-icon="photograph" placeholder="请扫描暂存区" @keydown.native.enter="(e)=>view(e.target.value)"/>
    </van-cell-group>
    <vxe-table ref="list" :data="list" :loading="loading" :max-height="720">
      <vxe-column field="order.stagingArea" title="暂存区"/>
      <vxe-column field="order.ordersCount" title="剩余任务数"/>
    </vxe-table>
    <van-tabbar fixed placeholder>
      <van-tabbar-item>
        <van-row gutter="20">
          <van-col span="10">
            <van-button block native-type="search" round style="margin: 10px;" type="info" @click="refresh">刷新</van-button>
          </van-col>
          <van-col span="10">
            <van-button :loading="loading" block native-type="toView" round style="margin: 10px;" type="info" @click="view">查看</van-button>
          </van-col>
        </van-row>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import { getUser } from '@/pdaView/utils'
import { Toast } from 'vant'

export default {
  name: 'ReviewHall',
  data() {
    return {
      loading: false,
      username: getUser().name,
      list: []
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    onClickLeft() {
      this.$router.push({ name: 'PdaIndex' })
    },
    goIndex() {
      this.$router.push({ name: 'PdaIndex' })
    },
    refresh() {
      findAll('reviewOverviewFactory', {}).then(res => {
        if (res.success) {
          this.list = res.result
        }
      })
    },
    view(value) {
      if (value) {
        this.$router.push({ name: 'StagingArea', params: { barcode: value } })
      } else {
        Toast('请先输入暂存区')
      }
    }
  }
}
</script>